<div class="modal-header" [ngClass]="iconTypeLayoutClass()">
  <span [innerHTML]="waitingTitle"></span>
  <button class="close" aria-label="Close" (click)="closeModal()" [ngClass]="iconCustomLayoutClass()">
    <img src="/assets/images/bt-close.svg" width="28px" height="28px" />
  </button>
</div>

<div class="modal-body">

   <!-- Description -->
   <div class="form-group row" [ngClass]="iconTypeLayoutClass()">
    <div class="col-sm-12 text-center" [innerHTML]="waitingSubtitle">
    </div>
  </div>
  <!-- ./ Description -->

</div>

<div class="modal-footer text-center">
  <button type="reset"
          [style.border]="'1px solid transparent'"
          (click)="closeModal()"
          class="btn btn-success small-btn"
          [ngClass]="buttonCustomLayoutCss()">
    {{ getTranslate("closeLabel") }}
  </button>
</div>
